// extracted by mini-css-extract-plugin
export default {"container":"PdfViewer_container__XJd95","nav":"PdfViewer_nav__HTvd5"};